export default "__VITE_ASSET__64PF_2iy__"